import MerchantInventoryDesktop from './MerchantInventoryDesktop'
import MerchantInventoryMobile from './MerchantInventoryMobile'

export default function MerchantInventoryPage() {
  return (
    <>
      <MerchantInventoryMobile />
      <MerchantInventoryDesktop />
    </>
  )
}
